(function(){if(window.elaaEditableHome)return;window.elaaEditableHome=true;const init=function(scope){const root=scope;switch(scope.dataset.elaaEditableSection){
case "hero":
(function(){

(function(){
const elaaScope = typeof root !== "undefined" && root.querySelectorAll ? root : document;

(() => {
elaaScope.querySelectorAll('[data-elaa-home]').forEach(root => {
if (root.dataset.ready) return;
root.dataset.ready = 'true';
const stage=root.querySelector('.eh-stage'), video=root.querySelector('video'), control=root.querySelector('.eh-control');
const header=root.querySelector('.eh-header');
const groups=[...header.querySelectorAll('[data-nav-group]')];
const menuToggle=root.querySelector('.eh-menu-toggle'), panel=root.querySelector('.eh-mobile-panel');
const instance='elaa-'+Math.random().toString(36).slice(2,9);
panel.id=instance+'-mobile';menuToggle.setAttribute('aria-controls',panel.id);
let closeTimer;
const closeGroups=()=>{clearTimeout(closeTimer);groups.forEach(g=>{g.querySelector('[data-mega-panel]').hidden=true;g.querySelector('[data-nav-trigger]').setAttribute('aria-expanded','false');});};
const closeMenu=()=>{panel.hidden=true;menuToggle.setAttribute('aria-expanded','false');menuToggle.setAttribute('aria-label','Open menu');};
const openGroup=g=>{closeGroups();closeMenu();g.querySelector('[data-mega-panel]').hidden=false;g.querySelector('[data-nav-trigger]').setAttribute('aria-expanded','true');};
groups.forEach((g,i)=>{
const trigger=g.querySelector('[data-nav-trigger]'), dropdown=g.querySelector('[data-mega-panel]');
trigger.id=instance+'-trigger-'+i;dropdown.id=instance+'-panel-'+i;
trigger.setAttribute('aria-controls',dropdown.id);dropdown.setAttribute('aria-labelledby',trigger.id);
g.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'&&!groups.some(other=>other!==g&&other.contains(document.activeElement)))openGroup(g);});
g.addEventListener('pointerleave',e=>{if(e.pointerType==='mouse')closeTimer=setTimeout(()=>{if(!g.contains(document.activeElement))closeGroups();},180);});
g.addEventListener('focusin',()=>{if(dropdown.hidden)openGroup(g);else clearTimeout(closeTimer);});
g.addEventListener('focusout',e=>{if(!g.contains(e.relatedTarget))closeGroups();});
trigger.addEventListener('keydown',e=>{if(e.key==='ArrowDown'){e.preventDefault();openGroup(g);dropdown.querySelector('a')?.focus();}});
// The first touch opens the panel; a second touch follows its overview link.
trigger.addEventListener('pointerdown',e=>{if(e.pointerType==='touch'||e.pointerType==='pen')trigger.dataset.touchWasOpen=String(!dropdown.hidden);});
trigger.addEventListener('click',e=>{if(trigger.dataset.touchWasOpen==='false'){e.preventDefault();openGroup(g);}delete trigger.dataset.touchWasOpen;});
});
menuToggle.addEventListener('click',()=>{closeGroups();panel.hidden=!panel.hidden;menuToggle.setAttribute('aria-expanded',String(!panel.hidden));menuToggle.setAttribute('aria-label',panel.hidden?'Open menu':'Close menu');});
document.addEventListener('keydown',e=>{
if(e.key!=='Escape')return;
if(!panel.hidden){closeMenu();menuToggle.focus();return;}
const open=groups.find(g=>!g.querySelector('[data-mega-panel]').hidden);
if(open){open.querySelector('[data-nav-trigger]').focus();closeGroups();}
});
document.addEventListener('pointerdown',e=>{if(!e.composedPath().includes(header)){closeGroups();closeMenu();}});
panel.addEventListener('click',e=>{if(e.target.closest('a'))closeMenu();});
panel.querySelectorAll('.eh-mobile-group').forEach(d=>d.addEventListener('toggle',()=>{if(d.open)panel.querySelectorAll('.eh-mobile-group').forEach(other=>{if(other!==d)other.open=false;});}));
if('ResizeObserver' in window){let previousMobile;new ResizeObserver(()=>{const mobile=root.clientWidth<=1000;if(mobile!==previousMobile){closeGroups();closeMenu();previousMobile=mobile;}}).observe(root);}
const reduced=matchMedia('(prefers-reduced-motion: reduce)');
let userPaused=false, failed=false, inView=true;
video.muted=true;
control.hidden=false;
const sync=()=>{stage.dataset.playing=String(!video.paused);control.setAttribute('aria-label',video.paused?'Play background film':'Pause background film');};
const play=()=>{if(!failed)video.play().catch(()=>sync());};
const fallback=()=>{failed=true;video.pause();stage.dataset.frame='poster';control.hidden=true;};
video.addEventListener('playing',()=>{stage.dataset.frame='video';sync();});
video.addEventListener('pause',sync);
video.addEventListener('error',fallback);
video.querySelector('source').addEventListener('error',fallback);
control.addEventListener('click',()=>{if(video.paused){userPaused=false;play();}else{userPaused=true;video.pause();}});
reduced.addEventListener('change',()=>{if(reduced.matches){video.pause();stage.dataset.frame='poster';}else if(!userPaused&&inView&&!document.hidden)play();});
document.addEventListener('visibilitychange',()=>{if(document.hidden)video.pause();else if(!userPaused&&!reduced.matches&&inView)play();});
if('IntersectionObserver' in window){new IntersectionObserver(entries=>{inView=entries[0].isIntersecting;if(!inView)video.pause();else if(!userPaused&&!reduced.matches&&!document.hidden)play();},{threshold:.12}).observe(stage);}
if(!reduced.matches&&!document.hidden)play();
sync();
});
})();

})();

})();

break;
case "freshness":
(function(){

(function(){
const elaaScope = typeof root !== "undefined" && root.querySelectorAll ? root : document;

(function () {
var script = document.currentScript;
var adjacent = script && script.previousElementSibling;
var roots = adjacent && adjacent.matches('.ef-dahlia-frame') ? [adjacent] : elaaScope.querySelectorAll('.ef-dahlia-frame');
roots.forEach(function (root) {
if (root.dataset.efReady === 'true') return;
var dialog = root.querySelector('.ef-dialog');
var openButton = root.querySelector('.ef-open');
if (!dialog || !openButton || typeof dialog.showModal !== 'function') return;
root.dataset.efReady = 'true';
root.querySelector('.ef-close').addEventListener('click', function () { dialog.close(); });
var previousOverflow;
openButton.addEventListener('click', function () {
if (dialog.open) return;
previousOverflow = document.documentElement.style.overflow;
dialog.showModal();
document.documentElement.style.overflow = 'hidden';
});
dialog.addEventListener('close', function () {
document.documentElement.style.overflow = previousOverflow || '';
openButton.focus({preventScroll:true});
});
dialog.addEventListener('click', function (event) {
if (event.target === dialog) dialog.close();
});
});
})();

})();

})();

break;
case "rituals":
(function(){

(function(){
const elaaScope = typeof root !== "undefined" && root.querySelectorAll ? root : document;

(function(){
function setup(root){
if(!root||root.dataset.erReady)return;
root.dataset.erReady='true';
var aperture=root.querySelector('.er-aperture'),photo=root.querySelector('.er-lotus-photo');
function alignPhoto(){
var s=root.getBoundingClientRect(),a=aperture.getBoundingClientRect();
if(!s.width)return;
// Keep the original scale and vertical crop; center the falling water in the lotus.
var scale=Math.max(s.width/1536,s.height/1024),imageWidth=1536*scale,imageHeight=1024*scale;
photo.style.setProperty('--er-scene-width',imageWidth+'px');
photo.style.setProperty('--er-scene-height',imageHeight+'px');
photo.style.setProperty('--er-scene-left',(a.width*.5-imageWidth*.59)+'px');
photo.style.setProperty('--er-scene-top',(s.top-a.top+(s.height-imageHeight)/2)+'px');
}
alignPhoto();
if(window.ResizeObserver){var observer=new ResizeObserver(alignPhoto);observer.observe(root);observer.observe(aperture)}
else window.addEventListener('resize',alignPhoto);
if(document.fonts)document.fonts.ready.then(alignPhoto);
var trigger=root.querySelector('.er-open'),dialog=root.querySelector('.er-dialog'),previousOverflow='';
trigger.addEventListener('click',function(){
if(dialog.open)return;
previousOverflow=document.documentElement.style.overflow;
dialog.showModal();document.documentElement.style.overflow='hidden';
trigger.setAttribute('aria-expanded','true');
});
dialog.addEventListener('close',function(){
document.documentElement.style.overflow=previousOverflow;
trigger.setAttribute('aria-expanded','false');trigger.focus({preventScroll:true});
});
dialog.addEventListener('keydown',function(e){
if(e.key!=='Tab')return;
var controls=Array.from(dialog.querySelectorAll('a[href],button:not([disabled])')).filter(function(el){return el.getClientRects().length});
var first=controls[0],last=controls[controls.length-1];
if(e.shiftKey&&(elaaScope.activeElement || document.activeElement)===first){e.preventDefault();last.focus()}
else if(!e.shiftKey&&(elaaScope.activeElement || document.activeElement)===last){e.preventDefault();first.focus()}
});
dialog.addEventListener('click',function(e){
if(e.target!==dialog)return;
var r=dialog.getBoundingClientRect();
if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();
});
}
var sibling=document.currentScript&&document.currentScript.previousElementSibling;
if(sibling&&sibling.matches('.er-section'))setup(sibling);
else elaaScope.querySelectorAll('.er-section').forEach(setup);
})();

})();

})();

break;
case "activated-oxygen":
(function(){

(function () {
  var scope = typeof root !== 'undefined' && root.querySelectorAll ? root : document;
  if (scope.__elaaOxygenDispose) scope.__elaaOxygenDispose();
  var active = new Map();
  var scopeAbort = new AbortController();
  function setup(el) {
    var video = el.querySelector('video'), button = el.querySelector('.ox-toggle');
    var old = active.get(el);
    var sourceKey = video ? (video.getAttribute('src') || '') + Array.from(video.querySelectorAll('source')).map(function (source) { return source.getAttribute('src') || ''; }).join('|') : '';
    if (old && old.video === video && old.button === button && old.sourceKey === sourceKey) { old.sync(); return; }
    if (old) { old.dispose(); active.delete(el); }
    if (!video || !button) return;
    var abort = new AbortController(), signal = abort.signal;
    var motion = matchMedia('(prefers-reduced-motion: reduce)');
    var visible = false, userPaused = false, manualPlay = false, observer;
    video.muted = true; button.hidden = false; el.dataset.hasFrame = 'false';
    if (old && old.video === video && old.sourceKey !== sourceKey) video.load();
    function update() {
      el.dataset.playing = String(!video.paused);
      button.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
    }
    function play() { var p = video.play(); if (p && p.catch) p.catch(update); }
    function sync() {
      var wants = manualPlay || (el.dataset.autoplay === 'true' && !motion.matches);
      if (visible && !document.hidden && !userPaused && wants) play(); else video.pause();
    }
    function failed() { el.dataset.hasFrame = 'false'; button.hidden = true; }
    video.addEventListener('playing', function () { el.dataset.hasFrame = 'true'; update(); }, { signal: signal });
    video.addEventListener('pause', update, { signal: signal });
    video.addEventListener('error', failed, { signal: signal });
    var sources = video.querySelectorAll('source'), failures = 0;
    sources.forEach(function (source) { source.addEventListener('error', function () {
      failures++; if (failures === sources.length) failed();
    }, { signal: signal }); });
    button.addEventListener('click', function () {
      if (video.paused) { userPaused = false; manualPlay = true; play(); }
      else { userPaused = true; video.pause(); }
    }, { signal: signal });
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting; sync();
      }, { threshold: 0.1 }); observer.observe(video.parentElement);
    } else { visible = true; sync(); }
    document.addEventListener('visibilitychange', sync, { signal: signal });
    motion.addEventListener('change', function () { manualPlay = false; sync(); }, { signal: signal });
    active.set(el, { video: video, button: button, sourceKey: sourceKey, sync: sync, dispose: function () {
      abort.abort(); if (observer) observer.disconnect(); video.pause();
    } });
    update();
  }
  function init() {
    active.forEach(function (state, el) {
      if (!scope.contains(el)) { state.dispose(); active.delete(el); }
    });
    scope.querySelectorAll('.ic-oxygen').forEach(setup);
  }
  var mutations = new MutationObserver(init);
  mutations.observe(scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-autoplay', 'src'] });
  function dispose() {
    mutations.disconnect(); active.forEach(function (state) { state.dispose(); }); active.clear(); scopeAbort.abort();
  }
  scope.__elaaOxygenDispose = dispose;
  document.addEventListener('shopify:section:unload', function (event) {
    if (scope.host && event.target.contains(scope.host)) dispose();
  }, { signal: scopeAbort.signal });
  init();
})();

})();

break;
case "love-letters":
(function(){

(function(){
const elaaScope = typeof root !== "undefined" && root.querySelectorAll ? root : document;

(function(){
function setup(root){
if(!root||root.dataset.llReady)return;
var letters;try{letters=JSON.parse(root.querySelector('[data-ll-data]').textContent)}catch(e){return}
if(!letters.length)return;root.dataset.llReady='true';
var panel=root.querySelector('.ll-panel'),quote=root.querySelector('.ll-quote'),author=root.querySelector('.ll-letter .ll-author'),counter=root.querySelector('.ll-counter'),letter=root.querySelector('.ll-letter'),expand=root.querySelector('.ll-expand'),toggle=root.querySelector('.ll-toggle'),dialog=root.querySelector('.ll-dialog'),announcement=root.querySelector('.ll-announcement');
var reduced=matchMedia('(prefers-reduced-motion: reduce)'),mobile=matchMedia('(max-width: 700px)');
var index=0,userPaused=reduced.matches||root.dataset.llAuto==='false',focusPaused=false,visible=false,timer=null,previousOverflow='',touch=null;
var pad=function(n){return String(n).padStart(2,'0')};
function stop(){if(timer!==null){clearTimeout(timer);timer=null}}
function schedule(){stop();if(visible&&!document.hidden&&!userPaused&&!focusPaused&&!dialog.open)timer=setTimeout(function(){go(index+1,false)},Math.max(5,Number(root.dataset.llSeconds)||8)*1000)}
function updateToggle(){toggle.setAttribute('aria-pressed',String(userPaused));toggle.setAttribute('aria-label',userPaused?'Resume automatic rotation':'Pause automatic rotation')}
function paint(manual){
var item=letters[index],max=mobile.matches?210:330,text=item.quote;
var isLong=text.length>max;
if(isLong){var part=text.slice(0,max+1),cut=part.lastIndexOf(' ');text=part.slice(0,cut>max*.72?cut:max).trim()+'…'}
quote.textContent=text;author.textContent=item.author;counter.textContent=pad(index+1)+' / '+pad(letters.length);expand.hidden=!isLong;
letter.setAttribute('aria-label','Love Letter '+(index+1)+' of '+letters.length);
if(manual)announcement.textContent='Love Letter '+(index+1)+' of '+letters.length+'. '+item.author;
}
function go(next,manual){index=(next+letters.length)%letters.length;paint(manual);schedule()}
root.querySelector('.ll-prev').addEventListener('click',function(){go(index-1,true)});
root.querySelector('.ll-next').addEventListener('click',function(){go(index+1,true)});
toggle.addEventListener('click',function(){userPaused=!userPaused;if(!userPaused)focusPaused=false;updateToggle();schedule()});
panel.addEventListener('focusin',function(e){if(e.target.matches(':focus-visible')){focusPaused=true;stop()}});
panel.addEventListener('focusout',function(e){if(!panel.contains(e.relatedTarget)){focusPaused=false;schedule()}});
panel.addEventListener('keydown',function(e){if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();go(index+(e.key==='ArrowLeft'?-1:1),true)}});
letter.addEventListener('touchstart',function(e){if(e.touches.length===1)touch=[e.touches[0].clientX,e.touches[0].clientY]},{passive:true});
letter.addEventListener('touchcancel',function(){touch=null},{passive:true});
letter.addEventListener('touchend',function(e){if(!touch)return;var t=e.changedTouches[0],dx=t.clientX-touch[0],dy=t.clientY-touch[1];touch=null;if(Math.abs(dx)>48&&Math.abs(dx)>Math.abs(dy))go(index+(dx<0?1:-1),true)},{passive:true});
expand.addEventListener('click',function(){
stop();var item=letters[index];root.querySelector('.ll-dialog-title').textContent='Love Letter '+pad(index+1);root.querySelector('.ll-full-quote').textContent=item.quote;root.querySelector('.ll-full-author').textContent=item.author;
previousOverflow=document.documentElement.style.overflow;dialog.showModal();dialog.scrollTop=0;document.documentElement.style.overflow='hidden';
});
dialog.addEventListener('close',function(){document.documentElement.style.overflow=previousOverflow;expand.focus({preventScroll:true});schedule()});
dialog.addEventListener('keydown',function(e){if(e.key==='Tab'){e.preventDefault();root.querySelector('.ll-close').focus()}});
dialog.addEventListener('click',function(e){if(e.target!==dialog)return;var b=dialog.getBoundingClientRect();if(e.clientX<b.left||e.clientX>b.right||e.clientY<b.top||e.clientY>b.bottom)dialog.close()});
if(window.IntersectionObserver)new IntersectionObserver(function(entries){visible=entries[0].isIntersecting;schedule()},{threshold:.1}).observe(panel);else{visible=true}
document.addEventListener('visibilitychange',schedule);
function motionChanged(){userPaused=reduced.matches||root.dataset.llAuto==='false';updateToggle();schedule()}
function sizeChanged(){paint(false);schedule()}
if(reduced.addEventListener){reduced.addEventListener('change',motionChanged);mobile.addEventListener('change',sizeChanged)}else{reduced.addListener(motionChanged);mobile.addListener(sizeChanged)}
paint(false);updateToggle();schedule();
}
var sibling=document.currentScript&&document.currentScript.previousElementSibling;
if(sibling&&sibling.matches('.ll-section'))setup(sibling);else elaaScope.querySelectorAll('.ll-section').forEach(setup);
})();

})();

})();

break;
}};function mount(parent){parent.querySelectorAll('[data-elaa-editable-section]').forEach(init)}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',()=>mount(document),{once:true})}else mount(document);document.addEventListener('shopify:section:load',e=>mount(e.target));})();